import { draftButtonHiddenStatuses } from '@utils/Util';

export const getQueryParamsFromArray = (array) => {
	return array.join(',');
};

export const isShowDraftButton = (product, requestFrom) => {
	if (product?.productStatusList && !product?.isSet && requestFrom !== 'SET_ORDER_DETAILS') {
		for (let i = 0; i < product?.productStatusList.length; i++) {
			if (draftButtonHiddenStatuses.includes(product?.productStatusList[i].status)) {
				return false;
			}
		}
	}
	return true;
};

export const formatNumberWithSuffix = (amount = 0) => {
	if (amount >= 1e9) {
		return (amount / 1e9).toFixed(1) + 'B';
	} else if (amount >= 1e6) {
		return (amount / 1e6).toFixed(1) + 'M';
	} else if (amount >= 1e3) {
		return (amount / 1e3).toFixed(1) + 'K';
	} else {
		return amount.toString();
	}
};
